
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecarrentalserviceprovderinpune() {



    const cardData =
    {
        keyword: 'Corporate Car Rental Service Provider in Pune ',
        heading: 'etravo : Corporate Car Rental Service Provider in Pune',



"headingDescription": "eTravo offers reliable Corporate Car Rental Services in Pune, designed for businesses, MNCs, IT companies, and professionals who need seamless mobility for employee transportation, airport transfers, client meetings, and corporate travel. With a fleet of well-maintained, GPS-enabled vehicles and experienced chauffeurs, eTravo ensures safe, punctual, and comfortable journeys. Flexible hourly, daily, and monthly rental plans make it a trusted corporate mobility partner across Pune.",

"top": "Top Corporate Car Rental Service Providers in Pune with eTravo",

"topPlaces": [
  {
    "title": "Hinjewadi IT Park",
    "description": "Pune’s largest IT hub with global companies, requiring large-scale corporate car rental and employee transportation solutions."
  },
  {
    "title": "Kharadi IT Park",
    "description": "A rapidly growing corporate district with EON IT Park and World Trade Center, demanding reliable fleet and executive travel services."
  },
  {
    "title": "Magarpatta City",
    "description": "A major IT township with Cybercity offices, ideal for structured employee pickup and drop services."
  },
  {
    "title": "Hadapsar",
    "description": "An important commercial and IT zone with SP Infocity and multiple corporate offices requiring daily business travel support."
  },
  {
    "title": "Baner-Balewadi",
    "description": "A fast-developing corporate hub with startups and IT companies requiring flexible car rental and mobility solutions."
  },
  {
    "title": "Viman Nagar",
    "description": "A premium business and residential area near Pune Airport, widely used for executive travel and corporate transfers."
  },
  {
    "title": "Koregaon Park",
    "description": "A high-end corporate locality with consulting firms, offices, and luxury hotels requiring premium rental services."
  },
  {
    "title": "Wakad",
    "description": "A key residential hub for IT professionals working in Hinjewadi, requiring daily corporate commute solutions."
  },
  {
    "title": "Shivajinagar",
    "description": "A central business district with government and corporate offices needing reliable transport services."
  },
  {
    "title": "Pimpri-Chinchwad",
    "description": "A major industrial and manufacturing hub with large workforce movement requiring structured corporate transportation."
  }
],


"services": [
{
"name": "Corporate Car Rental Provider Pune",
"description": "eTravo is a trusted corporate car rental provider in Pune offering reliable and professional transportation for businesses. Our service ensures punctual pickups, comfortable rides, and well-maintained vehicles for daily office commutes, executive travel, and client visits."
},
{
"name": "Company Car Hire Provider Pune",
"description": "eTravo provides company car hire services in Pune tailored for corporate needs. From employee transport to executive travel, our solutions ensure flexibility, reliability, and smooth daily operations."
},
{
"name": "Corporate Fleet Provider Pune",
"description": "Our corporate fleet services in Pune are designed for businesses requiring multiple vehicles. eTravo ensures consistent availability, proper maintenance, and efficient fleet management for seamless transportation."
},
{
"name": "Business Car Rental Pune",
"description": "eTravo offers business car rental services in Pune for professionals and organizations. Our service ensures comfortable, reliable, and punctual travel for meetings, site visits, and corporate activities."
},
{
"name": "Office Transport Provider Pune",
"description": "Simplify employee commuting with eTravo’s office transport services in Pune. We provide structured and reliable transportation solutions for daily office travel across all major business locations."
},
{
"name": "Corporate Mobility Provider Pune",
"description": "eTravo acts as a corporate mobility provider in Pune delivering end-to-end transport solutions. From planning to execution, we ensure efficient movement for employees and executives."
},
{
"name": "Professional Car Rental Pune",
"description": "Our professional car rental services in Pune are built to meet high corporate standards. eTravo ensures clean vehicles, trained drivers, and a smooth, comfortable travel experience."
},
{
"name": "Company Cab Provider Pune",
"description": "eTravo offers company cab services in Pune designed for efficient employee and executive travel. Our solutions ensure timely pickups, safe rides, and dependable service for businesses."
},
{
"name": "Corporate Taxi Provider Pune",
"description": "eTravo provides corporate taxi services in Pune for flexible and reliable business travel. Our taxis are ideal for meetings, airport transfers, and daily commuting with a focus on professionalism."
},
{
"name": "Employee Transport Provider Pune",
"description": "Our employee transport services in Pune ensure safe and efficient workforce mobility. eTravo provides well-planned routes, punctual pickups, and comfortable vehicles for daily commuting."
},
{
"name": "Corporate Travel Provider Pune",
"description": "eTravo offers corporate travel services in Pune covering both local and outstation needs. Our service ensures smooth and reliable travel for executives and employees."
},
{
"name": "Fleet Services Pune",
"description": "eTravo provides fleet services in Pune for businesses requiring multiple vehicles. Our fleet solutions ensure consistent quality, proper maintenance, and efficient operations."
},
{
"name": "Business Transport Pune",
"description": "eTravo offers business transport services in Pune designed for professional travel needs. Our service ensures reliable and comfortable transportation for corporate activities and daily commuting."
},
{
"name": "Corporate Car Services Pune",
"description": "Our corporate car services in Pune are tailored for businesses seeking dependable and professional travel solutions. eTravo ensures smooth and efficient transportation for all corporate requirements."
},
{
"name": "Office Cab Provider Pune",
"description": "eTravo provides office cab services in Pune for daily employee commuting. Our service ensures punctual pickups, comfortable rides, and reliable transportation for office travel."
}
],
"tableData": [
["Corporate Car Rental Provider Pune", "Company Car Hire Provider Pune"],
["Corporate Fleet Provider Pune", "Business Car Rental Pune"],
["Office Transport Provider Pune", "Corporate Mobility Provider Pune"],
["Professional Car Rental Pune", "Company Cab Provider Pune"],
["Corporate Taxi Provider Pune", "Employee Transport Provider Pune"],
["Corporate Travel Provider Pune", "Fleet Services Pune"],
["Business Transport Pune", "Corporate Car Services Pune"],
["Office Cab Provider Pune", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Trusted Corporate Car Rental Service Provider in Pune",
      "WhyChoosedescription": "eTravo is a reliable corporate car rental service provider in Pune, offering professional and scalable transportation solutions for businesses, ensuring smooth travel for employees, executives, and clients."
    },
    {
      "WhyChooseheading": "End-to-End Corporate Mobility Solutions",
      "WhyChoosedescription": "Corporate car rental providers in Pune offer complete travel services including employee transport, airport transfers, business travel, and event transportation, ensuring seamless corporate mobility. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "Flexible Rental and Leasing Options",
      "WhyChoosedescription": "Top providers offer flexible plans such as hourly rentals, daily bookings, monthly packages, and long-term leasing options tailored to business requirements. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Wide Fleet of Corporate Vehicles",
      "WhyChoosedescription": "Corporate car rental companies provide a diverse fleet including hatchbacks, sedans, SUVs, and luxury cars, ensuring suitable options for employee transport and executive travel. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Professional Chauffeurs and Safety Standards",
      "WhyChoosedescription": "Experienced drivers with corporate etiquette and safety training ensure secure, smooth, and professional travel experiences for all business journeys."
    },
    {
      "WhyChooseheading": "Advanced Fleet Management and Tracking",
      "WhyChoosedescription": "Modern corporate rental providers use GPS tracking, centralized monitoring, and smart fleet management systems to ensure efficiency and real-time travel visibility. :contentReference[oaicite:3]{index=3}"
    },
    {
      "WhyChooseheading": "Cost-Effective and Transparent Pricing",
      "WhyChoosedescription": "Corporate car rental services help businesses reduce costs by eliminating fleet maintenance and offering transparent billing with no hidden charges. :contentReference[oaicite:4]{index=4}"
    },
    {
      "WhyChooseheading": "24/7 Support for Business Travel Needs",
      "WhyChoosedescription": "Dedicated support teams ensure round-the-clock assistance for bookings, schedule changes, and emergencies, keeping corporate travel uninterrupted."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is a corporate car rental service provider in Pune?',
            answer: 'A corporate car rental service provider in Pune offers chauffeur-driven vehicles and transport solutions for businesses including employee commute, airport transfers, and executive travel.',
        },
        {
            question: 'What services do corporate car rental providers offer?',
            answer: 'They offer employee transportation, airport transfers, business travel, outstation trips, and event transport solutions for corporate clients. :contentReference[oaicite:5]{index=5}',
        },
        {
            question: 'Can companies book long-term corporate car rentals in Pune?',
            answer: 'Yes, most providers offer long-term leasing and monthly rental plans customized for business operations. :contentReference[oaicite:6]{index=6}',
        },
        {
            question: 'What types of vehicles are available for corporate rental?',
            answer: 'Corporate fleets include hatchbacks, sedans, SUVs, and luxury cars depending on travel requirements. :contentReference[oaicite:7]{index=7}',
        },
        {
            question: 'Are corporate car rental services safe for employees?',
            answer: 'Yes, services include GPS tracking, verified drivers, and safety protocols to ensure secure travel.',
        },
        {
            question: 'Do corporate car rental companies provide airport transfers?',
            answer: 'Yes, airport pickup and drop services are a key offering for corporate travelers.',
        },
        {
            question: 'Can corporate travel plans be customized?',
            answer: 'Yes, providers offer flexible and customizable travel plans based on company needs and schedules.',
        },
        {
            question: 'Do these services operate 24/7?',
            answer: 'Yes, most corporate car rental providers operate round the clock to support business travel needs.',
        },
        {
            question: 'How do corporate car rentals help businesses?',
            answer: 'They improve productivity, reduce travel stress, and eliminate the need for maintaining company-owned vehicles. :contentReference[oaicite:8]{index=8}',
        },
        {
            question: 'How can I book a corporate car rental service in Pune?',
            answer: 'You can book through the service provider’s website or contact their corporate support team for customized travel solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Sandeep Patil',
        designation: 'Operations Manager, IT Company, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo is a highly professional corporate car rental service provider in Pune. Their punctual service and well-maintained fleet have made employee transport seamless for our company.”',
    },
    {
        name: 'Ms. Ritu Sharma',
        designation: 'HR Head, Corporate Firm, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for all our corporate travel needs. Their flexible plans, safety features, and reliable support make them the best choice in Pune.”',
    },
];










    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Car Rental Service Provider in Pune",
  "image": "https://www.etravo.in/images/keyword/corporate-car-rental-provider-pune.jpg",
  "description": "Trusted corporate car rental service provider in Pune by eTravo. We offer company car hire, employee transport, corporate fleet services, and complete business mobility solutions with reliable and professional service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-car-rental-service-provider-in-pune"
  }
};




    return (
        <div>

<Helmet>
  <title>Corporate Car Rental Service Provider in Pune | Fleet & Transport Solutions | eTravo</title>
  <meta 
    name="description" 
    content="Hire a corporate car rental service provider in Pune with eTravo for company car hire, employee transport, corporate fleet services, and complete business mobility solutions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/133.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecarrentalserviceprovderinpune;